import { Routes } from '@angular/router';

export const routes: Routes = [
    { path: '', loadChildren: () => import('./hsts/hsts.module').then(m => m.HstsModule) },
];
